import { API_ROOT } from '../../supplementary_components/requests';
import { addPopup } from '../../supplementary_components/store';
import { ConfirmationDialogue } from '../../general_components/forms/ConfirmationDialogue';
import { PURCHASE_TYPE_OPTIONS, purchaseTypeLabel } from './purchaseTypeOptions';

function showLessor(select) {
    const show = select.value === 'LEASE' || select.value === 'LEASED_TO_OWN';
    let form = select;
    while (form && form.tagName !== 'FORM') {
        form = form.parentNode;
    }
    const input = form?.querySelector('[name="lessorName"]');
    if (!input) return;
    input.disabled = !show;
    input.parentNode.style.display = show ? 'block' : 'none';
    if (!show) input.value = '';
}

const HISTORY_TYPES = ['LEASE', 'LEASED_TO_OWN', 'FINANCED'];

function dropsPaymentHistory(previousType, nextType) {
    const prev = previousType || null;
    const next = nextType || null;
    if (!prev || prev === next) return false;
    const leaseFamily = prev === 'LEASE' || prev === 'LEASED_TO_OWN';
    const nextLeaseFamily = next === 'LEASE' || next === 'LEASED_TO_OWN';
    if (leaseFamily && nextLeaseFamily) return false;
    return HISTORY_TYPES.includes(prev);
}

export function confirmIfPurchaseTypeDropsHistory(previousType, nextType) {
    const next = nextType || null;
    const prev = previousType || null;
    if (!dropsPaymentHistory(prev, next)) return Promise.resolve(true);
    return new Promise((resolve) => {
        let settled = false;
        const finish = (accepted) => {
            if (settled) return;
            settled = true;
            resolve(accepted);
        };
        addPopup({
            content: ConfirmationDialogue,
            popupData: {
                formTitle: 'Change purchase type',
                name: 'confirmPurchaseTypeChange',
                message: 'Payment history will be removed if you continue. Do you wish to proceed?',
                submitTitle: 'Proceed',
                action: (done) => {
                    finish(true);
                    done(true);
                },
                cancelAction: (close) => {
                    finish(false);
                    close();
                },
            },
            EZCloseAllowed: false,
        });
    });
}

export function equipmentPurchaseColumns(page) {
    const data = page?.data ?? page ?? {};
    if (data?.thirdPartyTrailer || data?.truckType === 'Owner') return [];
    const leased = data?.purchaseType === 'LEASE' || data?.purchaseType === 'LEASED_TO_OWN';
    return [
        {
            notInAddForm: true,
            label: 'Purchase Type',
            name: 'purchaseType',
            type: 'select',
            dataset: PURCHASE_TYPE_OPTIONS,
            defaultValue: () => data.purchaseType || '',
            val: data.purchaseType ? purchaseTypeLabel(data.purchaseType) : '-',
            onChange: (event) => {
                const select = event.target;
                const next = select.value || '';
                const prev = data.purchaseType || '';
                if (!dropsPaymentHistory(prev, next)) {
                    showLessor(select);
                    if (page) page.purchaseTypeConfirmed = next;
                    return;
                }
                select.value = prev;
                showLessor(select);
                confirmIfPurchaseTypeDropsHistory(prev, next).then((accepted) => {
                    if (!accepted) {
                        showLessor(select);
                        return;
                    }
                    select.value = next;
                    if (page) page.purchaseTypeConfirmed = next;
                    showLessor(select);
                });
            },
            processBeforeSending: (val) => val || null,
        },
        {
            notInAddForm: true,
            label: 'Lessor',
            name: 'lessorName',
            autoComplete: 'off',
            suggestionsEnabled: true,
            suggestionsLink: API_ROOT + 'lessors?pattern=',
            displayValueGenerator: (lessor) => lessor?.name ?? '',
            suggestOnEachKey: true,
            noValidation: true,
            customDisplayMode: leased ? undefined : 'none',
            disabled: !leased,
            defaultValue: () => data.lessorName || '',
            val: data.lessorName || '-',
            processBeforeSending: (val) => {
                const name = val != null ? String(val).trim() : '';
                if (page?.data) page.pendingLessorName = name;
                return name;
            },
        },
    ];
}
